import React from "react";
import Update from "./Update";
import Delete from "./Delete";

import {
  Fade,
  Card,
  Stack,
  Checkbox,
  CardHeader,
  CardActionArea,
} from "@mui/material";

import { useSelector } from "react-redux";
import { hasRequiredRole } from "helpers";

export default function Model({
  model,
  delay,
  checked,
  refetch,
  isAssign,
  handleSelect,
}) {
  const { id, title, media } = model;
  const { roles } = useSelector((state) => state.auth.userInfo);
  const isAdmin = hasRequiredRole(["superAdmin"], roles);

  return (
    <>
      <Fade
        in
        timeout={{ appear: delay * 150, enter: delay * 170, exit: delay * 190 }}
      >
        <Stack direction="row" alignItems="center">
          {isAssign && (
            <Checkbox size="small" checked={checked} onChange={handleSelect} />
          )}
          <Card
            sx={{
              width: "100%",
              position: "relative",
              bgcolor: checked && "action.disabledBackground",
            }}
            variant="outlined"
          >
            <CardHeader
              sx={{ p: 1 }}
              title={title}
              action={
                <Stack direction="row" columnGap={0.5}>
                  <Update id={id} refetch={refetch} />
                  <Delete id={id} refetch={refetch} />
                </Stack>
              }
            />
            <CardActionArea
              sx={{
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 1,
                position: "absolute",
              }}
              disabled={!isAssign}
              onClick={handleSelect}
            />
          </Card>
        </Stack>
      </Fade>
    </>
  );
}
